
<script lang="ts" setup>
import { reactive } from "vue";
import CusPopup from "./CusPopup.vue";
import { useGlobalData, gamerToken } from '@/utils/useGlobal';
import { toast } from "@/utils/global";
import SubscribePrizeList from "./SubscribePrizeList.vue";
import { engage, userProfile, BaiduOcpc } from '../api';
import { emit } from "@/utils/eventBus";
import { os } from "@/utils/env"
import { track } from '@/libs/track';
import { getQueryString } from "@/utils/url";

const { isShowSubscribePop, isShowSubscribeSuccessPop, config, currentActivity, userInfo, isSubscribed, subscribeCount } = useGlobalData()

const platform = reactive({
  list: [
    {
      id: 1,
      name: "Android",
      value:"Android"
    },
    {
      id: 2,
      name: "iOS",
      value:"iOS"
    },
    {
      id: 3,
      name: "windows",
      value:"windows"
    }
  ]
}) 

// 保存选中的预约平台
let selectedPlatformValues: {list:string[] }= reactive({
  list:[]
})

// ios / android / pc / other
function initSelectPlatForm() {
  if (os === "android") {
    selectedPlatformValues.list.push("Android")
  } else if (os === "ios") {
    selectedPlatformValues.list.push("iOS")
  } else {
    selectedPlatformValues.list.push("windows")
  }
}

initSelectPlatForm();

function changePlatform(value: string) {
  const index = selectedPlatformValues.list.findIndex(item => item === value)
  if (index > -1) {
    selectedPlatformValues.list.splice(index, 1);
  } else {
    selectedPlatformValues.list.push(value)
  }
}

let reqStatus = false;
// 提交预约
async function submit() {
  track.trackWebModuleClick({
    module_id: 'btn_pre_register',
  })
  // 活动配置错误
  if (!currentActivity.value) return;
  if (!selectedPlatformValues.list.length) {
    toast("请选择预约平台")
    return;
  }
  if (reqStatus) return;
  reqStatus = true;
  try {
    const { status, data } = await engage(
      {
      feature_id: currentActivity.value.feature_id,
      engagement: {
        platforms: selectedPlatformValues.list
      }
      }, gamerToken.value)
    if (status === 401) {
      isShowSubscribePop.value = false;
      emit("handleLogin");
      return 
    }
    if (data) {
      // 请求 获取当前登录用户基础信息 userProfile， 获取 通行证ID 和 手机号
      const { ok, status, data } = await userProfile(gamerToken.value)
      if (status === 401) {
        isShowSubscribePop.value = false;
        emit("handleLogin");
        return 
      }
      if (!ok) return;
      if (data) {
        userInfo.value = data
        track.trackPreRegister({
          user_id: data.user_id,
          pre_register_platform: selectedPlatformValues.list
        })

      }
      // 更改预约状态
      isSubscribed.value = true
      // 显示预约成功弹窗
      isShowSubscribeSuccessPop.value = true
      // 更改预约数
      subscribeCount.value += 1
      const bd_vid = getQueryString("bd_vid")
      BaiduOcpc({
        url: bd_vid ? location.href : undefined,
      })
    }
  } catch (error) {
    toast("预约失败, 请稍后再试~")
  } finally {
    reqStatus = false;
  }
}

</script>
<template>
  <CusPopup v-if="isShowSubscribePop" @close="isShowSubscribePop = false">
    <div class="subscribe-pop">
        <template v-if="!isShowSubscribeSuccessPop">
          <span class="title">预约进入朝歌</span>
          <div class="select-platform">
            <span>选择预约平台</span>
            <ul class="platform-list">
              <li 
              v-for="item in platform.list" 
              :key="item.id" 
              class="platform-item" 
              :class="{'active': selectedPlatformValues.list.includes(item.value)}"
              @click="changePlatform(item.value)">
                <span class="platform-icon"></span>
                <span class="platform-value">{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <button class="subscribe-btn" @click="submit">立即预约</button>
        </template>
        <div v-if="isShowSubscribeSuccessPop" class="success-infor">
          <span>通行证 ID：{{ userInfo.user_id }}</span>
          <span>手机号：{{ userInfo.mobile }} </span>
        </div>
        <div
          :class="{
            'subscribe-success-box': isShowSubscribeSuccessPop,
            'subscribe-infor-wrap': !isShowSubscribeSuccessPop
          }"
        >
          <div class="subscribe-qr-code" v-if="isShowSubscribeSuccessPop">
            <div class="qr-code">
              <img v-if="config.service" :src="config.service" alt="weixin">
            </div>
            <span>{{config.serviceDesc}}</span>
          </div>
          <span class="divider"></span>
          <div class="subscribe-success-gift">
            <span v-if="isShowSubscribeSuccessPop" class="success-title">您已预约成功</span>
            <div
            :class="{
              'subscribe-gift-wrap': isShowSubscribeSuccessPop,
              'subscribe-gift-wrap-normal': !isShowSubscribeSuccessPop
            }"
           >
              <span v-if="!isShowSubscribeSuccessPop" class="gift-title">公测预约好礼</span>
              <p class="gift-tip">公测开启后，使用世游通行证登录官网包可领取官网预约奖励。</p>
              <SubscribePrizeList/>
            </div>
          </div>
        </div>
    </div>
  </CusPopup>
</template>
<style lang="less" scoped>
.subscribe-pop{
  display: flex;
  flex-direction: column;
  align-items: center;
  width:8rem;
  height:5.03rem;
  color: #FEFCE7;
  background: url("~/images/pop/bg1.png") no-repeat 0 0 / 100%;
  .title{
    display: block;
    width:2.73rem;
    height:0.6rem;
    margin-top:-0.14rem;
    text-indent:-9999rem;
    background: url("~/images/pop/enter-title.png") no-repeat 0 0 / 100%;
  }
  .select-platform{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top:0.3rem;
    font-size: 0.16rem;
  }
  .platform-list{
    display: flex;
  }
  .platform-item{
    display: flex;
    align-items: center;
    justify-content: center;
    width:1.64rem;
    height:0.4rem;
    margin-left:0.14rem;
    cursor: pointer;
    background: url("~/images/pop/platform-bg.png") no-repeat 0 0 / 100%;
    &.active{
      .platform-icon{
        &::before, &::after{
          opacity: 1;
        }
      }
    }
  }
  .platform-icon{
    position: relative;
    display:inline-block;
    width: 0.14rem;
    height: 0.14rem;
    margin-right:0.16rem;
    border: 0.01rem solid #FEFCE7;
    &::before{
      position: absolute;
      top: -0.13rem;
      right: -0.01rem;
      display: inline-block;
      font-size:0.24rem;
      content:"√";
      opacity: 0;
      transition: all .2s;
    }
  }
  .subscribe-btn{
    width:2.13rem;
    height:0.61rem;
    margin-top:0.34rem;
    text-indent:-9999rem;
    background: url("~/images/pop/subscribe-btn.png") no-repeat 0 0 / 100%;
  }
}
.subscribe-infor-wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.gift-wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top:0.26rem;
  color: #FFFEEA;

}
.gift-title{
  display: block;
  width: 3.49rem;
  height:0.58rem;
  text-indent:-9999rem;
  background: url("~/images/pop/gift-title.png") no-repeat 0 0 / 100%;
}
.gift-tip{
  margin-top: 0.15rem;
  font-size: 0.2rem;
  color: #3F230F;
}
.subscribe-success-gift{
  margin-top:0.15rem;
}
.subscribe-gift-wrap-normal{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.divider{
  display: block;
  width: 100%;
  margin-top:0.3rem;
  &::before{
    display: block;
    width: 100%;
    height: 0.01rem;
    content: "";
    background: linear-gradient(to right, RGBA(104, 85, 58, 0), RGBA(104, 85, 58, 1), RGBA(104, 85, 58, 0));
  }
  &::after{
    display: block;
    width: 100%;
    height: 0.01rem;
    content: "";
    background: linear-gradient(to right, RGBA(184, 156, 117, 0), RGBA(184, 156, 117, 1), RGBA(184, 156, 117, 0));
  }
}

.subscribe-success-box{
  display: flex;
  justify-content: space-between;
  width: 96%;
  .subscribe-qr-code, .subscribe-success-gift{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .subscribe-qr-code{
    justify-content: center;
    width: 40%;
      
    & > span{
      display: block;
      padding: 0 0.1rem;
      margin-top: 0.12rem;
      font-size: 0.2rem;
      line-height: 0.3rem;
      color: #FECF93;
      text-align: center;
      opacity: 0.7;
    }
  }
  .qr-code{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.03rem;
    height: 2.04rem;
    background: #94684A;
    border: 0.01rem solid #704A1B;
    border-radius: 0.21rem;
  
    & > img{
      width: 90%;
      border-radius: 0.1rem;
    }
  }
  .subscribe-success-gift{
    width: 56%;
  }
  .subscribe-gift-wrap{
    width: 100%;
    text-align: center;
  }
  .divider{
    width: 0.02rem;
    margin-top:0;
    &::before{
      display: inline-block;
      width: 0.01rem;
      height: 100%;
      content: "";
      background: linear-gradient(to bottom, RGBA(104, 85, 58, 0), RGBA(104, 85, 58, 1), RGBA(104, 85, 58, 0));
    }
    &::after{
      display: inline-block;
      width: 0.01rem;
      height: 100%;
      content: "";
      background: linear-gradient(to bottom, RGBA(184, 156, 117, 0), RGBA(184, 156, 117, 1), RGBA(184, 156, 117, 0));
    }
  }
  .gift-wrap{
    margin-top: 0.3rem;
  }
  .gift-tip{
    padding-right:0.15rem;
    margin-top: 0.1rem;
    line-height: 1.4;
    
  }
  :deep(.gift-list){
    flex-wrap: wrap;
    margin: 0.22rem auto 0;
    .gift-item{
      width: 1.3rem;
      margin: 0 0.01rem 0.3rem;
    }
  }
  .success-title{
    width:3.49rem;
    height:0.58rem;
    text-indent:-9999rem;
    background: url("~/images/pop/success-title.png") no-repeat 0 0 / 100%;
  }
 
}
.success-infor{
  width: 100%;
  padding: 0 0.46rem;
  margin-top:0.46rem;
  font-size: 0.22rem;
  & > span:nth-child(2){
    display: inline-block;
    margin-left:0.4rem;
  }
}
.pc{
  .subscribe-pop{
    width:8rem;
  }
 
}
.wap{
  .subscribe-pop{
    width:7.5rem;
    height: 4.8rem;
  }
  .subscribe-btn{
    margin-top:0.24rem;
  }
  .subscribe-success-gift{
    margin-top: 0.1rem;
  }
  .divider {
    margin-top: 0.2rem;
  }
  .subscribe-success-box{
    :deep(.gift-list){
      flex-wrap: wrap;
      margin: 0.22rem auto 0;
      .gift-item{
        margin: 0 0 0.2rem;
      }
    }
    .gift-tip{
      margin-top: 0.16rem;
    }
  }
}
</style>
